import { createSlice } from '@reduxjs/toolkit';

export const router = createSlice({
  name: 'router',
  initialState: {
    current: {},
  },
  reducers: {
    setCurrentRoute: (state, action) => {
      state.current = action.payload;
    },
  },
});

export const { setCurrentRoute } = router.actions;

export const selectCurrentRoute = (state) => state.router.current;

export default router.reducer;
